import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** TokenType property - Definition */
export class DocsBlockTokenTypePropertyDefinition extends DocsBlockPropertyDefinition {
}
